<!-- <Tooltip :text="data?.itemType" length="8" /> -->
<template>
  <a-tooltip :title="safeHover">
    <p class="cursor-pointer">
      {{ safeText }}
    </p>
  </a-tooltip>
</template>

<script>
import { trimText } from "@/core/helpers/utility";
export default {
  name: "tooltip",
  data() {
    return {
      trimText,
    };
  },
  props: {
    text: {
      type: [String, null],
      default: null,
    },
    length: {
      type: [Number, String],
      required: true,
      default: 8,
    },
    hoverText: {
      type: String,
      required: false,
    },
  },

  computed: {
    safeText() {
      return this.text ? trimText(this.text, this.length) : "N/A";
    },
    safeHover() {
      return this.hoverText || this.text || "N/A";
    },
  },
};
</script>
